import { FC, memo } from 'react'

import { Container, InnerContainer, QuoteContainer, QuoteIconContainer, QuoteText } from './styles'
import QuoteIcon from '../../../assets/icons/quote-feather.svg'

interface QuoteSectionProps {
    quote: string
}

const QuoteSection: FC<QuoteSectionProps> = ({ quote }) => {
    return (
        <Container id="quote">
            <InnerContainer>
                <QuoteContainer>
                    <QuoteIconContainer>
                        <QuoteIcon />
                    </QuoteIconContainer>
                    <QuoteText>{quote}</QuoteText>
                </QuoteContainer>
            </InnerContainer>
        </Container>
    )
}

export default memo(QuoteSection)
